import { Disclosure } from "@headlessui/react";
import React from "react";
import { BsChevronDown } from "react-icons/bs";
import {
  useOrderStatus,
  useProductOrderStatuses,
} from "../../../../api/order-management/use-order-status";
import ExchangeInformationTable from "./Section/ExhangeInformationTable";
import Filter from "./Section/Filter";
import NormalPaymentTable from "./Section/NormalPaymentTable";
import OrderCancellationRefundTable from "./Section/OrderCancellationRefundTable";
import OrderCancellationTable from "./Section/OrderCancellationTable";
import ReturnAndRefundInformationTable from "./Section/ReturnAndRefundInformationTable";
import ReturnInformationTable from "./Section/ReturnInformationTable";
import { OrderTable } from "../order-table";

export const OrderStatus = () => {
  const [appliedFilter, setAppliedFilter] = React.useState({});
  const [filterKey, setFilterKey] = React.useState(0);
  const { data } = useProductOrderStatuses();
  const { isEmpty, getDataTableProps } = useOrderStatus(appliedFilter);
  const normalPaymentData = data?.data?.normalPayment;
  const exchangeData = data?.data?.exchange;
  const cancelationData = data?.data?.cancelation;
  const cancelationRefundData = data?.data?.cancelationRefund;
  const returnData = data?.data?.return;
  const returnRefundData = data?.data?.returnRefund;

  const onSubmitFilter = (filter) => {
    setAppliedFilter(filter);
  };

  const onResetFilter = () => {
    setAppliedFilter({});
    setFilterKey((prev) => prev + 1);
  };

  return (
    <div className="block">
      <div className="mt-2">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button className="border-t -mt-3 border-b border-[#dddddd] flex w-full justify-between py-3 text-left text-xs font-medium text-black focus:outline-none focus-visible:ring focus-visible:ring-opacity-75">
                <span className="font-bold">주문 현황 정보</span>
                <BsChevronDown
                  className={`transition-all ${
                    open ? "rotate-180 transform" : ""
                  } h-5 w-5 text-[#cccccc]`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="pt-4 pb-2 text-[11px] text-gray-500">
                <div className="mt-2">
                  <div className="flex gap-4">
                    {/* 정상 결제 정보 table */}
                    <div className="w-[70%]">
                      <NormalPaymentTable data={normalPaymentData} />
                    </div>
                    {/* 교환 정보 table */}
                    <div className="w-[30%]">
                      <ExchangeInformationTable data={exchangeData} />
                    </div>
                  </div>
                  {/* Separator */}
                  <div className="bg-[#ededed] h-[10px] my-4" />
                  {/* Tables */}
                  <div className="flex gap-4">
                    {/* 주문 취소 정보 table */}
                    <div className="w-[50%]">
                      <OrderCancellationTable data={cancelationData} />
                    </div>
                    {/* 주문 취소 환불정보 (미입금 제외) table */}
                    <div className="w-[50%]">
                      <OrderCancellationRefundTable
                        data={cancelationRefundData}
                      />
                    </div>
                  </div>
                  {/* Separator */}
                  <div className="bg-[#ededed] h-[10px] my-4" />
                  {/* Tables */}
                  <div className="flex gap-4">
                    {/* 반품 정보 table */}
                    <div className="w-[50%]">
                      <div className="p-2 bg-primary-blue text-white font-bold">
                        반품 정보
                      </div>
                      <ReturnInformationTable data={returnData} />
                    </div>
                    {/* 반품 환불정보 (반품거부 제외) table */}
                    <div className="w-[50%]">
                      <ReturnAndRefundInformationTable
                        data={returnRefundData}
                      />
                    </div>
                  </div>

                  {/* Separator */}
                  <div className="bg-[#ededed] h-[25px] my-4" />
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Filter
          key={filterKey}
          onSubmitFilter={onSubmitFilter}
          onResetFilter={onResetFilter}
          isOrderManagement={true}
        />
        <OrderTable isEmpty={isEmpty} getDataTableProps={getDataTableProps} />
      </div>
    </div>
  );
};
